import { StepConnector, StepLabel, Stepper, stepConnectorClasses, stepIconClasses, stepLabelClasses, styled } from '@mui/material';
export var StyledStepper = styled(Stepper)(function (_a) {
  var theme = _a.theme;
  return {
    paddingTop: theme.typography.pxToRem(14),
    paddingBottom: theme.typography.pxToRem(12),
    backgroundColor: theme.palette.common.white
  };
});
export var StyledStepLabel = styled(StepLabel)(function (_a) {
  var _b, _c;
  var theme = _a.theme;
  return _b = {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700
  }, _b[".".concat(stepIconClasses.root)] = {
    borderRadius: '50%',
    border: "".concat(theme.typography.pxToRem(1), " solid ").concat(theme.palette.grey[500]),
    width: '2rem',
    height: '2rem',
    fill: 'none'
  }, _b[".".concat(stepIconClasses.active)] = (_c = {
    fill: theme.palette.text.primary,
    borderWidth: 0
  }, _c[".".concat(stepIconClasses.text)] = {
    fill: theme.palette.common.white
  }, _c), _b[".".concat(stepIconClasses.text)] = {
    fill: theme.palette.text.primary
  }, _b[".".concat(stepLabelClasses.label, ".").concat(stepLabelClasses.alternativeLabel)] = {
    marginTop: theme.spacing(0.25)
  }, _b[".".concat(stepLabelClasses.alternativeLabel, " .").concat(stepLabelClasses.completed)] = {
    textDecoration: 'underline',
    color: theme.palette.primary.main,
    cursor: 'pointer'
  }, _b[".".concat(stepLabelClasses.alternativeLabel, " .").concat(stepLabelClasses.active)] = {
    textDecoration: 'unset',
    color: theme.palette.text.primary,
    fontWeight: 700
  }, _b;
});
export var StyledStepConnector = styled(StepConnector)(function (_a) {
  var _b;
  var theme = _a.theme;
  return _b = {
    top: theme.typography.pxToRem(16)
  }, _b[".".concat(stepConnectorClasses.line)] = {
    borderTopStyle: 'dashed',
    borderTopWidth: theme.typography.pxToRem(4)
  }, _b;
});